import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { UpdateElaborationComponent } from 'app/entities/monitoring/actual/elaboration/updateelaboration/update-elaboration.component';
import { Elaboration } from 'app/shared/models/elaboration.model';
import { ElaborationService } from './elaboration.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'elaboration-info',
  providers: [ElaborationService],
  templateUrl: './elaboration.component.html',
  styleUrls: ['./elaboration.component.css']
})

/**
 * Component to display the monitoring elaboration for the entity.
 */
export class ElaborationComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;

  dialogRef: MdDialogRef<any>;
  elaborationData: string;
  elaborationLoaded = false;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private elaborationService: ElaborationService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      this.getElaborationDesc();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getElaborationDesc() {
    this.elaborationLoaded = false;
    this.elaborationData = "";
    this.elaborationService.getElaborationDesc(this.id, this.entityIdDetails.entityType)
        .subscribe(response => {
        this.elaborationData = response;
        this.elaborationLoaded = true;
    });
  }

  // Open dialog having text editor to update Monitoring Elaboration text.
  openElaborationUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdateElaborationComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argElaborationDetailsData = this.elaborationData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getElaborationDesc();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/elaboration/elaboration.component.ts